
import useTranslation from "./Hooks/UseTranslation";

type Submenu = {
    text: string;
    path: string;
    icon: string;
    active: boolean;
    disabled?: boolean;
    itemWidth?: number;
    alignRight?: boolean;
}

type Menu = {
    text: string;
    textWidth?: number;
    path: string;
    icon: string;
    active: boolean;
    submenu?: Submenu[];
    disabled?: boolean;
    itemWidth?: number;
    alignRight?: boolean;
}

type Navigation = [
    Menu[],
    Submenu[]
]

const getNavigation = (project_id: string, active_menu: string, active_submenu: string): Navigation => {

    const { t } = useTranslation()

    let menu: any
    let submenu: any

    const projectPath = (path: string) => project_id ? `/project/${project_id}${path}` : '/'

    const getShellMenu = () => [
        {
            text: 'Proyectos',
            path: `/`,
            icon: `icon-mis_proyectos`,
            active: active_menu === 'homepage',
            itemWidth: 126,
        },
        {
            text: 'Dashboard',
            path: projectPath('/'),
            icon: `icon-dashboard`,
            active: active_menu === 'home',
            disabled: !project_id,
            itemWidth: 126,
            submenu: [
                {
                    text: t('NAVIGATION:ProjectDashboard'),
                    path: projectPath('/'),
                    icon: `icon-dashboard`,
                    active: active_submenu === 'dashboard',
                    disabled: !project_id,
                    itemWidth: 126,
                },
                {
                    text: t('NAVIGATION:ProjectInfo'),
                    path: projectPath('/info'),
                    icon: `icon-informacion`,
                    active: active_submenu === 'info',
                    disabled: !project_id,
                    itemWidth: 132,
                },
            ],
        },
        {
            text: t('NAVIGATION:Teams'),
            path: projectPath('/teams'),
            icon: `icon-equipos`,
            active: active_menu === 'teams',
            disabled: !project_id,
            itemWidth: 116,
        },
        {
            text: t('NAVIGATION:Programmation'),
            path: projectPath('/programmation-macro'),
            icon: `icon-programacion`,
            active: active_menu === 'programmation',
            disabled: !project_id,
            itemWidth: 154,
            submenu: [
                {
                    text: t('NAVIGATION:ProgrammationMacro'),
                    path: projectPath('/programmation-macro'),
                    icon: `icon-macro`,
                    active: active_submenu === 'macro',
                    disabled: !project_id,
                    itemWidth: 130,
                },
                {
                    text: t('NAVIGATION:ProgrammationLookahead'),
                    path: projectPath('/programmation-lookahead'),
                    icon: `icon-lookahead`,
                    active: active_submenu === 'lookahead',
                    disabled: !project_id,
                    itemWidth: 162,
                },
                {
                    text: t('NAVIGATION:ProgrammationWeekly'),
                    path: projectPath('/programmation-weekly'),
                    icon: `icon-semanal`,
                    active: active_submenu === 'weekly',
                    disabled: !project_id,
                    itemWidth: 150,
                },
            ],
        },
        {
            text: t('NAVIGATION:Tasks'),
            path: projectPath('/tasks'),
            icon: `icon-tareas`,
            active: active_menu === 'tasks',
            disabled: !project_id,
            itemWidth: 112,
            submenu: [
                {
                    text: t('NAVIGATION:TasksBoard'),
                    path: projectPath('/tasks'),
                    icon: `icon-tablero`,
                    active: active_submenu === 'board',
                    disabled: !project_id,
                    itemWidth: 118,
                },
                {
                    text: t('NAVIGATION:TasksDataBase'),
                    path: projectPath('/tasks-archive'),
                    icon: `icon-base_de_datos`,
                    active: active_submenu === 'archive',
                    disabled: !project_id,
                    itemWidth: 142,
                },
            ],
        },
        {
            text: t('NAVIGATION:Resources'),
            path: projectPath('/resources/restrictions'),
            icon: `icon-recursos`,
            active: active_menu === 'resources',
            disabled: !project_id,
            itemWidth: 124,
            submenu: [
                {
                    text: t('NAVIGATION:ResourcesRestrictions'),
                    path: projectPath('/resources/restrictions'),
                    icon: `icon-restricciones_recurso`,
                    active: active_submenu === 'restrictions',
                    disabled: !project_id,
                    itemWidth: 150,
                },
                {
                    text: t('NAVIGATION:ResourcesCNC'),
                    path: projectPath('/resources/cnc'),
                    icon: `icon-cnc_recurso`,
                    active: active_submenu === 'cnc',
                    disabled: !project_id,
                    itemWidth: 94,
                },
            ],
        },
        {
            text: t('NAVIGATION:Indicators'),
            path: projectPath('/indicators/ppc'),
            icon: `icon-indicadores`,
            active: active_menu === 'indicators',
            disabled: !project_id,
            itemWidth: 142,
            submenu: [
                {
                    text: t('NAVIGATION:IndicatorsPPC'),
                    path: projectPath('/indicators/ppc'),
                    icon: `icon-ppc_indicador`,
                    active: active_submenu === 'ppc',
                    disabled: !project_id,
                    itemWidth: 88,
                },
                {
                    text: t('NAVIGATION:IndicatorsCNC'),
                    path: projectPath('/indicators/cnc'),
                    icon: `icon-cnc_recurso`,
                    active: active_submenu === 'cnc',
                    disabled: !project_id,
                    itemWidth: 88,
                },
            ],
        },
        {
            text: 'BIM',
            path: `/`,
            icon: `icon-recursos`,
            active: false,
            disabled: true,
            itemWidth: 86,
        },
        {
            text: 'Protocolos',
            path: `/`,
            icon: `icon-tareas`,
            active: false,
            disabled: true,
            itemWidth: 130,
        },
        {
            text: 'Configuración',
            path: `/profile`,
            icon: `icon-configuracion`,
            active: active_menu === 'profile',
            itemWidth: 154,
            alignRight: true,
        },
    ]

    if (active_menu === 'homepage' || active_menu === 'chat' || active_menu === 'profile') {

        menu = []

        submenu = getShellMenu()

        return [ menu, submenu ]
    }


    if (!project_id) return [[], []]

    menu = getShellMenu()

    submenu = menu.find((item: any) => item.active)?.submenu || []

    return [ menu, submenu ]
}

export default {
    getNavigation,
}
